import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexGrid,
  ApexXAxis
} from "ng-apexcharts";
import { SortConfig } from '../../core/interface/SortConfig';
import { PaginationConfig } from '../../core/interface/PaginationConfig';
import { debounceTime, distinctUntilChanged, Subject, Subscription, takeUntil } from 'rxjs';
import { Hotel, HotelDetail, HotelDetailAveragePrice, HotelDetailFacilities, HotelFbOutletRevenue, HotelDetailOccupancy, HotelDetailRevenue, HotelGallery, ImageItem, Meta } from '../../core/models/hotel';
import { ActivatedRoute, Router } from '@angular/router';
import { HotelService } from '../../core/services/hotel.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
};

@Component({
  selector: 'app-hotel-detail',
  templateUrl: './hotel-detail.component.html',
  styleUrl: './hotel-detail.component.css'
})

export class HotelDetailComponent implements OnInit {

  @ViewChild("chart") chart!: ChartComponent;
  public chartOptions!: ChartOptions;
  public chartOptionsAveragePrice !: ChartOptions;

  // Data arrays
  facilitiesData: any[] = []; // Untuk data Property Facilities
  fbOutletsData: any[] = []; // Untuk data F&B Outlets

  revenueItem: HotelDetailRevenue[] = [];
  ItemDetailHotel: HotelDetail = {} as HotelDetail;
  ItemDetailHotelOccupancy: HotelDetailOccupancy = {} as HotelDetailOccupancy;
  ItemDetailHotelAveragePrice: HotelDetailAveragePrice = {} as HotelDetailAveragePrice;

  images: ImageItem[] = [];
  filteredImages: ImageItem[] = [];
  currentImageIndex: number = 0;
  currentVisibleImageIndex: number = 0;
  currentFilter: string = 'All Photos';
  categoryNames: string[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 1;
  metaData: Meta = {} as Meta;
  MaxValueLength: number = 0;
  MaxLengthRoom: number = 0;

  itemHotel: HotelDetailFacilities[] = [];
  itemFbOutlets: HotelFbOutletRevenue[] = [];

  isLoading = false;
  error = '';

  // Filters
  searchForm !: FormGroup;
  sortBy = '';
  startDate: string = '';
  endDate: string = ''

  sortConfig: SortConfig = {
    column: '',
    direction: ''
  };

  paginationConfig: PaginationConfig = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0
  };

  searchTerm: string = '';

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();
  private routeSub: Subscription | null = null;

  isLoadingOccupancy = false;
  isLoadingAverageRoom = false;

  // Pagination untuk Facilities
  facilitiesPaginationConfig = {
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0
  };

  // Pagination untuk F&B Outlets
  fbOutletsPaginationConfig = {
    itemsPerPage: 13,
    currentPage: 1,
    totalItems: 0
  };

  expandedStates: boolean[] = [];
  isTotalExpanded: boolean = false;

  // Index untuk setiap section
  totalIndex: number = -1;
  roomIndex: number = -1;
  fbIndex: number = -1;
  fbRestoIndex: number = -1;
  fbMiceIndex: number = -1;
  otherIndex: number = -1;

  // Panggil fungsi ini setelah data revenueItem LOADED/DITERIMA
  findSectionIndexes() {
    console.log('Total items di revenueItem:', this.revenueItem.length);
    
    // Reset semua index ke -1 dulu
    this.totalIndex = -1;
    this.roomIndex = -1;
    this.fbIndex = -1;
    this.fbRestoIndex = -1;
    this.fbMiceIndex = -1;
    this.otherIndex = -1;
    
    // Cari index setiap section
    this.revenueItem.forEach((item, idx) => {
      console.log(`Item ${idx}:`, item.name);
      switch(item.name) {
        case 'Total': this.totalIndex = idx; break;
        case 'Room': this.roomIndex = idx; break;
        case 'F&B': this.fbIndex = idx; break;
        case 'F&B - Restaurant': this.fbRestoIndex = idx; break;
        case 'F&B - Mice': this.fbMiceIndex = idx; break;
        case 'Other': this.otherIndex = idx; break;
      }
    });

    // 🔥 Ubah dari fill(false) menjadi fill(true)
    this.expandedStates = new Array(this.revenueItem.length).fill(true); // ✅ SEMUA EXPANDED
    
    // 🔥 Set isTotalExpanded menjadi true juga
    this.isTotalExpanded = true;
  }  
  
  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private hotelService: HotelService
  ) {
    this.setupSearchSubscription();

    this.searchForm = this.fb.group({
      searchTerm: ['']
    });
  }

  ngOnInit(): void {
    // Initialize filter dengan default value
    this.filterImages('All Photos');

    // Load dates dari localStorage
    this.loadDatesFromLocalStorage();

    // Load semua data yang diperlukan
    this.loadAllData();

    // Subscribe ke route query parameters
    this.subscribeToRouteParams();

    this.revenueItem.forEach((item, idx) => {
      switch(item.name) {
        case 'Room': this.roomIndex = idx; break;
        case 'F&B': this.fbIndex = idx; break;
        case 'F&B - Restaurant': this.fbRestoIndex = idx; break;
        case 'F&B - Mice': this.fbMiceIndex = idx; break;
        case 'Other': this.otherIndex = idx; break;
      }
    });
    
    // Inisialisasi expandedStates
    this.isTotalExpanded = true;
    this.expandedStates = new Array(this.revenueItem.length).fill(true);
  }

  // Toggle Total (Master)
  toggleTotal() {
    console.log('=== TOGGLE TOTAL DIPANGGIL ===');
    console.log('Sebelum:', {
        isTotalExpanded: this.isTotalExpanded,
        expandedStates: [...this.expandedStates]
    });
    
    this.isTotalExpanded = !this.isTotalExpanded;
    
    console.log('Setelah toggle:', {
        isTotalExpanded: this.isTotalExpanded,
        akan_set_semua_ke: this.isTotalExpanded
    });
    
    // Expand/collapse semua section
    if (this.roomIndex !== -1) {
        this.expandedStates[this.roomIndex] = this.isTotalExpanded;
        console.log(`Room (index ${this.roomIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.fbIndex !== -1) {
        this.expandedStates[this.fbIndex] = this.isTotalExpanded;
        console.log(`F&B (index ${this.fbIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.fbRestoIndex !== -1) {
        this.expandedStates[this.fbRestoIndex] = this.isTotalExpanded;
        console.log(`F&B Restaurant (index ${this.fbRestoIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.fbMiceIndex !== -1) {
        this.expandedStates[this.fbMiceIndex] = this.isTotalExpanded;
        console.log(`F&B Mice (index ${this.fbMiceIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.otherIndex !== -1) {
        this.expandedStates[this.otherIndex] = this.isTotalExpanded;
        console.log(`Other (index ${this.otherIndex}) → ${this.isTotalExpanded}`);
    }
    
    console.log('Akhir:', {
        isTotalExpanded: this.isTotalExpanded,
        expandedStates: [...this.expandedStates]
    });
  }

  // Toggle individual section
  toggleExpand(index: number) {
    this.expandedStates[index] = !this.expandedStates[index];
  }

  


  private loadDatesFromLocalStorage(): void {
    const startDate = localStorage.getItem('startDate');
    const endDate = localStorage.getItem('endDate');

    this.startDate = startDate || '';
    this.endDate = endDate || '';
  }

  private loadAllData(): void {
    this.loadHotelDetailRevenue();
    this.loadHotelDetail();
    this.loadHotelDetailOccupancy();
    this.loadHotelDetailAveragePrice();
  }

  private subscribeToRouteParams(): void {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.searchTerm = params['search'] || '';
        this.sortConfig.column = params['sortColumn'] || '';
        this.sortConfig.direction = (params['sortDirection'] as 'ASC' | 'DESC') || '';
        this.paginationConfig.currentPage = Number(params['page']) || 1;

        this.loadHotelDetailFacilities(this.searchTerm);
        this.loadHotelFbOutletRevenue(this.searchTerm);
        
      });
  }

  // Method untuk refresh data (ketika filter tanggal berubah)
  public refreshDashboardData(): void {

    // Update localStorage jika diperlukan
    if (this.startDate) localStorage.setItem('startDate', this.startDate);
    if (this.endDate) localStorage.setItem('endDate', this.endDate);

    // Reload data
    this.loadHotelDetailOccupancy();
    this.loadHotelDetailAveragePrice();
    this.loadHotelDetail();
    this.loadHotelDetailRevenue();
  }

  get firstFilePath(): string | null {
    if (!this.ItemDetailHotel?.hotelGallery) {
      return null;
    }

    return this.ItemDetailHotel.hotelGallery.reduce<string | null>((foundPath, gallery) => {
      if (foundPath) return foundPath;

      if (gallery.files && gallery.files.length > 0) {
        const fileWithPath = gallery.files.find(file => file.path);
        return fileWithPath?.path || null;
      }

      return null;
    }, null);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  private initChartData(chartData: any[], MaxValueLength: number): void {
    const seriesData = chartData.map(item => item.value);
    const formattedDates = chartData.map(item => item.date);

    const xaxisLabelColors = Array(chartData.length).fill("#B6D1C1");
    if (chartData.length > 0) {
      xaxisLabelColors[chartData.length - 1] = "#191919";
    }

    this.chartOptions = {
      series: [{
        name: "Persentase",
        data: seriesData,
      }],
      chart: {
        height: 400,
        width: '100%',
        type: "bar",
        events: {
          click: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
          mouseMove: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
        },
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
      },
      colors: Array(chartData.length).fill("#B6D1C1"),
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          distributed: true,
          dataLabels: {
            position: 'top'
          }
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%"
        },
        offsetY: -25,
        style: {
          fontSize: '12px',
          colors: ["#126936"],
          fontWeight: 'bold'
        },
        distributed: true,
      },
      legend: {
        show: false
      },
      grid: {
        show: true,
        position: 'back',
        borderColor: '#E6E6E6',
        xaxis: {
          lines: {
            show: false
          },
        },
        yaxis: {
          lines: {
            show: false,
          }
        },
        padding: {
          left: 20
        }
      },
      xaxis: {
        categories: formattedDates,
        labels: {
          rotate: -45,
          trim: false,
          hideOverlappingLabels: false,
          rotateAlways: true,
          style: {
            colors: xaxisLabelColors,
            cssClass: 'apexcharts-xaxis-label',
            fontSize: "12px",
            fontWeight: 'bold'
          },
          offsetY: 8,
          offsetX: 10
        },
        tickPlacement: 'on',
      },
      yaxis: {
        title: {
          text: ""
        },
        min: 0,
        max: MaxValueLength,
        tickAmount: 5,
        labels: {
          formatter: function (val) {
            return val + "%"
          },
          style: {
            colors: '#666666',
            fontSize: '12px',
            fontWeight: 'normal'
          },
          offsetX: 10
        },
        axisBorder: {
          show: true,
          color: "#E6E6E6"
        },
        axisTicks: {
          show: true,
          color: "#E6E6E6",
          width: 6,
          offsetX: 0
        },
        crosshairs: {
          show: false
        },
        opposite: false
      },
    };
  }

  private initChartDataAveragePrice(chartData: any[], MaxLengthRoom: number): void {
    const seriesData = chartData.map(item => item.value);
    const formattedDates = chartData.map(item => item.date);

    const xaxisLabelColors = Array(chartData.length).fill("#B6D1C1");
    if (chartData.length > 0) {
      xaxisLabelColors[chartData.length - 1] = "#191919";
    }

    this.chartOptionsAveragePrice = {
      series: [{
        name: "Persentase",
        data: seriesData,
      }],
      chart: {
        height: 400,
        width: '100%',
        type: "bar",
        events: {
          click: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
          mouseMove: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
        },
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
      },
      colors: Array(chartData.length).fill("#B6D1C1"),
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          distributed: true,
          dataLabels: {
            position: 'top'
          },
          borderRadius: 0
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%"
        },
        offsetY: -25,
        style: {
          fontSize: '12px',
          colors: ["#126936"],
          fontWeight: 'bold'
        },
        distributed: true,
      },
      legend: {
        show: false
      },
      grid: {
        show: true,
        position: 'back',
        borderColor: '#E6E6E6',
        xaxis: {
          lines: {
            show: false
          },
        },
        yaxis: {
          lines: {
            show: false,
          }
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 20
        }
      },
      xaxis: {
        categories: formattedDates,
        labels: {
          rotate: -45,
          trim: false,
          hideOverlappingLabels: false,
          rotateAlways: true,
          style: {
            colors: xaxisLabelColors,
            cssClass: 'apexcharts-xaxis-label',
            fontSize: "12px",
            fontWeight: 'bold'
          },
          offsetY: 8,
          offsetX: 10
        },
        tickPlacement: 'on',
      },
      yaxis: {
        title: {
          text: ""
        },
        min: 0,
        max: MaxLengthRoom,
        tickAmount: 5,
        labels: {
          formatter: function (val) {
            return val + "%"
          },
          style: {
            colors: '#666666',
            fontSize: '12px',
            fontWeight: 'normal'
          },
          offsetX: 10
        },
        axisBorder: {
          show: true,
          color: "#E6E6E6"
        },
        axisTicks: {
          show: true,
          color: "#E6E6E6",
          width: 6,
          offsetX: 0
        },
        crosshairs: {
          show: false
        },
        opposite: false
      },
    };
  }

  openGalleryModal(content: any): void {
    const options: any = {
      centered: true,
      windowClass: 'hotel-gallery-modal',
      backdrop: 'static',
      keyboard: false
    };

    if (window.innerWidth >= 768) {
      options.size = 'xl';
      options.fullscreen = 'lg';
    }

    this.modalService.open(content, options);
  }

  processGalleryData(): void {
    this.categoryNames = ['All Photos'];

    if (this.ItemDetailHotel && this.ItemDetailHotel.hotelGallery && this.ItemDetailHotel.hotelGallery.length > 0) {
      const uniqueCategories = new Set<string>();
      const processedImages: ImageItem[] = [];

      this.ItemDetailHotel.hotelGallery.forEach((gallery: HotelGallery) => {
        if (gallery.category_name && gallery.files && gallery.files.length > 0) {
          uniqueCategories.add(gallery.category_name);

          gallery.files.forEach(file => {
            if (file.path) {
              processedImages.push({
                src: file.path,
                type: gallery.category_name,
                alt: file.name || gallery.category_name || 'Hotel Image'
              });
            }
          });
        }
      });

      this.images = processedImages;
      this.categoryNames = [...this.categoryNames, ...Array.from(uniqueCategories)];
      this.filterImages('All Photos');
    } else {
      this.images = [];
      this.filteredImages = [];
      this.categoryNames = ['All Photos'];
    }
  }

  filterImages(filter: string): void {
    this.currentFilter = filter;

    if (filter === 'All Photos') {
      this.filteredImages = [...this.images];
    } else {
      this.filteredImages = this.images.filter(img => img.type === filter);
    }

    this.currentPage = 1;
    this.currentVisibleImageIndex = 0;
  }

  prev(): void {
    if (this.filteredImages.length === 0) return;

    if (this.currentVisibleImageIndex > 0) {
      this.currentVisibleImageIndex--;
    } else {
      this.currentVisibleImageIndex = this.filteredImages.length - 1;
    }

    this.currentPage = this.currentVisibleImageIndex + 1;
  }

  next(): void {
    if (this.filteredImages.length === 0) return;

    if (this.currentVisibleImageIndex < this.filteredImages.length - 1) {
      this.currentVisibleImageIndex++;
    } else {
      this.currentVisibleImageIndex = 0;
    }

    this.currentPage = this.currentVisibleImageIndex + 1;
  }

  get currentImage(): ImageItem {
    if (this.filteredImages.length > 0 && this.currentVisibleImageIndex < this.filteredImages.length) {
      return this.filteredImages[this.currentVisibleImageIndex];
    }
    return { src: '', type: '', alt: 'No image available' };
  }

  getTotalPages(): number {
    return this.filteredImages.length;
  }

  private setupSearchSubscription(): void {
    this.searchSubject.pipe(
      takeUntil(this.destroy$),
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      if (term.trim()) {
        this.updateUrlParams();
      }
      this.loadHotelDetailFacilities(term);
      this.loadHotelFbOutletRevenue(term);
    });
  }

  loadHotelDetail(): void {
    this.isLoading = true;
    const paramsId = this.route.snapshot.paramMap.get('id');

    if (!paramsId) {
      console.error('Hotel ID not found in route parameters');
      this.isLoading = false;
      return;
    }

    this.hotelService.getHotelDetail(
      Number(paramsId),
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        if (response && response.data) {
          this.ItemDetailHotel = response.data;
          this.processGalleryData();
        } else {
          console.warn('Invalid response structure:', response);
          this.ItemDetailHotel = {} as HotelDetail;
        }

        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading Hotel Detail data:', error);
        this.isLoading = false;
        this.ItemDetailHotel = {} as HotelDetail;
        this.error = 'Failed to load hotel details';
      }
    });
  }

  // Method untuk memisahkan data facilities dan fb outlets
  separateData(facilities: any[]): void {
    // Filter untuk Facilities (bukan F&B)
    this.facilitiesData = facilities;
    /*this.facilitiesData = facilities.filter(item => 
      !item.categoryName?.includes('F&B') && 
      !item.categoryName?.includes('Restaurant') &&
      !item.categoryName?.includes('Bar') &&
      !item.categoryName?.includes('Cafe')
    );*/
    
    // Filter untuk F&B Outlets
    this.fbOutletsData = facilities.filter(item => 
      item.categoryName?.includes('F&B') || 
      item.categoryName?.includes('Restaurant') ||
      item.categoryName?.includes('Bar') ||
      item.categoryName?.includes('Cafe')
    );
    
    // Reset pagination ke halaman pertama
    this.facilitiesPaginationConfig.currentPage = 1;
    this.fbOutletsPaginationConfig.currentPage = 1;
  }

  onImageError(event: any): void {
    console.error('Failed to load image:', event.target.src);
    event.target.src = 'assets/images/placeholder-hotel.jpg';
  }

  onImageLoad(event: any): void {
    console.log('Image loaded successfully:', event.target.src);
  }

  hasGalleryData(): boolean {
    return this.ItemDetailHotel &&
      this.ItemDetailHotel.hotelGallery &&
      this.ItemDetailHotel.hotelGallery.length > 0;
  }

  getTotalImagesCount(): number {
    return this.images.length;
  }

  hasImagesForCurrentFilter(): boolean {
    return this.filteredImages && this.filteredImages.length > 0;
  }

  getCategoriesWithCount(): Array<{ name: string, count: number }> {
    const categoriesWithCount: Array<{ name: string, count: number }> = [];

    this.categoryNames.forEach(category => {
      if (category === 'All Photos') {
        categoriesWithCount.push({
          name: category,
          count: this.images.length
        });
      } else {
        const count = this.images.filter(img => img.type === category).length;
        categoriesWithCount.push({
          name: category,
          count: count
        });
      }
    });

    return categoriesWithCount;
  }

  private isValidImageUrl(url: string): boolean {
    if (!url || typeof url !== 'string') return false;

    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  loadHotelDetailOccupancy(): void {
    const paramsId = this.route.snapshot.paramMap.get('id');
    this.isLoading = true;
    this.isLoadingOccupancy = true;

    this.hotelService.getHotelDetailOccupancy(
      Number(paramsId),
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.ItemDetailHotelOccupancy = response.data;
        this.MaxValueLength = response.data.max_pct_value;
        this.isLoading = false;

        this.initChartData(response.data.chart, this.MaxValueLength);

        this.isLoadingOccupancy = false;
      },
      error: (error) => {
        console.error('Error loading Hotel Detail Occupancy data:', error);
        this.isLoading = false;
        this.ItemDetailHotelOccupancy = {} as HotelDetailOccupancy;
        this.initChartData([], 0);
        this.isLoadingOccupancy = false;
      }
    });
  }

  loadHotelDetailAveragePrice(): void {
    const paramsId = this.route.snapshot.paramMap.get('id');
    this.isLoading = true;
    this.isLoadingAverageRoom = true;

    this.hotelService.getHotelDetailAveragePrice(
      Number(paramsId),
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.ItemDetailHotelAveragePrice = response.data;
        this.MaxLengthRoom = response.data.max_pct_value;
        this.isLoading = false;
        this.isLoadingAverageRoom = false;

        this.initChartDataAveragePrice(response.data.chart, this.MaxLengthRoom);
      },
      error: (error) => {
        console.error('Error loading Hotel Detail Average Price data:', error);
        this.isLoading = false;
        this.ItemDetailHotelAveragePrice = {} as HotelDetailAveragePrice;
        this.initChartDataAveragePrice([], 0);
        this.isLoadingAverageRoom = false;
      }
    });
  }

  
  loadHotelDetailRevenue(): void {
    this.isLoading = true;

    const hotelId = this.route.snapshot.paramMap.get('id') || 0

    this.hotelService.getHotelDetailRevenue(
      hotelId,
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.revenueItem = response.data;
        this.metaData = response.meta;
        this.isLoading = false;
        this.findSectionIndexes();
      },
      error: (error) => {
        console.error('Error loading revenue data:', error);
        this.isLoading = false;
        this.revenueItem = [];
      }
    });
  }

  loadHotelDetailFacilities(searchTerm?: string): void {
    this.isLoading = true;
    this.error = '';
    const paramsId = this.route.snapshot.paramMap.get('id');

    this.hotelService.getHotelDetailFacilities(
      paramsId || '',
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      searchTerm?.trim() || '',
      this.sortConfig.column,
      this.sortConfig.direction ? this.sortConfig.direction.toUpperCase() as 'ASC' | 'DESC' : undefined,
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        if (response && response.data) {
          this.itemHotel = response.data;
          
          // Pisahkan data untuk facilities dan fb outlets
          //this.separateData(response.data);
          this.facilitiesData = response.data;
          if (response.pagination) {
            this.paginationConfig.totalItems = response.pagination.total_items;
            this.paginationConfig.currentPage = response.pagination.current_page;
          }

          this.isLoading = false;
        } else {
          this.error = 'Respons API tidak valid';
          this.isLoading = false;
          this.itemHotel = [];
        }
      },
      error: (error) => {
        let errorMessage = 'Error saat memuat data hotel property: ';

        if (error.status === 200 && error.statusText === 'OK') {
          errorMessage += 'Error saat memproses format respons JSON';
        } else if (error.error instanceof ErrorEvent) {
          errorMessage += `Error client: ${error.error.message}`;
        } else {
          errorMessage += `Kode: ${error.status}, Pesan: ${error.message}`;
        }

        console.error(errorMessage, error);
        this.error = errorMessage;
        this.isLoading = false;
        this.itemHotel = [];
      }
    });
  }

  loadHotelFbOutletRevenue(searchTerm?: string): void {
    this.isLoading = true;
    this.error = '';
    const paramsId = this.route.snapshot.paramMap.get('id');

    this.hotelService.getHotelFbOutletRevenue(
      paramsId || '',
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      searchTerm?.trim() || '',
      this.sortConfig.column,
      this.sortConfig.direction ? this.sortConfig.direction.toUpperCase() as 'ASC' | 'DESC' : undefined,
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        if (response && response.data) {
          this.itemFbOutlets = response.data;
          
          // Pisahkan data untuk facilities dan fb outlets
          //this.separateData(response.data);
          this.fbOutletsData = response.data;
          if (response.pagination) {
            this.paginationConfig.totalItems = response.pagination.total_items;
            this.paginationConfig.currentPage = response.pagination.current_page;
          }

          this.isLoading = false;
        } else {
          this.error = 'Respons API tidak valid';
          this.isLoading = false;
          this.itemFbOutlets = [];
        }
      },
      error: (error) => {
        let errorMessage = 'Error saat memuat data hotel property: ';

        if (error.status === 200 && error.statusText === 'OK') {
          errorMessage += 'Error saat memproses format respons JSON';
        } else if (error.error instanceof ErrorEvent) {
          errorMessage += `Error client: ${error.error.message}`;
        } else {
          errorMessage += `Kode: ${error.status}, Pesan: ${error.message}`;
        }

        console.error(errorMessage, error);
        this.error = errorMessage;
        this.isLoading = false;
        this.itemFbOutlets = [];
      }
    });
  }

  onSearch(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const term = target.value;

    this.searchTerm = term;
    this.paginationConfig.currentPage = 1;
    this.searchSubject.next(term);

    if (!term.trim()) {
      const queryParams: Record<string, string | number | null> = {
        page: 1,
        search: null
      };

      if (this.sortConfig.column && this.sortConfig.direction) {
        queryParams['sortColumn'] = this.sortConfig.column;
        queryParams['sortDirection'] = this.sortConfig.direction;
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        replaceUrl: true
      });

      this.loadHotelDetailFacilities('');
    }
  }

  onSort(column: string): void {
    if (this.sortConfig.column === column) {
      this.sortConfig.direction = this.sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortConfig.column = column;
      this.sortConfig.direction = 'ASC';
    }

    this.paginationConfig.currentPage = 1;
    this.updateUrlParams();
    this.loadHotelDetailFacilities(this.searchTerm);
  }

  getSortIcon(column: string): string {
    if (this.sortConfig.column !== column) {
      return 'ri-expand-up-down-line';
    }

    if (this.sortConfig.direction === 'ASC') {
      return 'ri-arrow-up-line';
    } else if (this.sortConfig.direction === 'DESC') {
      return 'ri-arrow-down-line';
    }

    return 'ri-expand-up-down-line';
  }

  private updateUrlParams(): void {
    const queryParams: any = {
      page: this.paginationConfig.currentPage
    };

    if (this.searchTerm?.trim()) {
      queryParams.search = this.searchTerm.trim();
    } else {
      queryParams.search = null;
    }

    if (this.sortConfig.column && this.sortConfig.direction) {
      queryParams.sortColumn = this.sortConfig.column;
      queryParams.sortDirection = this.sortConfig.direction;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  get totalPages(): number {
    return Math.ceil(this.paginationConfig.totalItems / this.paginationConfig.itemsPerPage);
  }

  get pageNumbers(): number[] {
    const currentPage = this.paginationConfig.currentPage;
    const totalPages = this.totalPages;

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  get displayRange(): { start: number; end: number; total: number } {
    const start = (this.paginationConfig.currentPage - 1) * this.paginationConfig.itemsPerPage + 1;
    const end = Math.min(
      start + this.paginationConfig.itemsPerPage - 1,
      this.paginationConfig.totalItems
    );

    return {
      start: this.paginationConfig.totalItems === 0 ? 0 : start,
      end,
      total: this.paginationConfig.totalItems
    };
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.paginationConfig.currentPage = 1;
    this.updateUrlParams();
    this.loadHotelDetailFacilities('');
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.paginationConfig.currentPage) {
      return;
    }

    this.paginationConfig.currentPage = page;
    this.updateUrlParams();
    this.loadHotelDetailFacilities(this.searchTerm);
  }

  onFirstPage(): void {
    this.onPageChange(1);
  }

  onLastPage(): void {
    this.onPageChange(this.totalPages);
  }

  onPrevPage(): void {
    this.onPageChange(this.paginationConfig.currentPage - 1);
  }

  onNextPage(): void {
    this.onPageChange(this.paginationConfig.currentPage + 1);
  }

  getFbTotal(): number {
    const restaurant = this.revenueItem.find(item => item.name === 'F&B - Restaurant');
    const mice = this.revenueItem.find(item => item.name === 'F&B - Mice');
    
    const restaurantTotal = restaurant ? restaurant.total : 0;
    const miceTotal = mice ? mice.total : 0;
    
    return Math.round(restaurantTotal + miceTotal);
  }

  getFbBudget(): number {
    const restaurant = this.revenueItem.find(item => item.name === 'F&B - Restaurant');
    const mice = this.revenueItem.find(item => item.name === 'F&B - Mice');
    
    const restaurantTotal = restaurant ? restaurant.budget : 0;
    const miceTotal = mice ? mice.budget : 0;
    
    return Math.round(restaurantTotal + miceTotal);
  }

  getFbPct(): number {
    const fbTotal = this.getFbTotal();
    const fbBudget = this.getFbBudget();
    
    if (fbBudget === 0) {
      return 100;
    }
    
    return Math.round(((fbTotal - fbBudget) / fbBudget * 100) * 100) / 100;
  }

  getTotalRevenue(): number {
    return this.revenueItem.reduce((total, item) => total + item.total, 0);
  }

  // COMPUTED PROPERTIES UNTUK FACILITIES
  get paginatedFacilities() {
    const startIndex = (this.facilitiesPaginationConfig.currentPage - 1) * this.facilitiesPaginationConfig.itemsPerPage;
    const endIndex = startIndex + this.facilitiesPaginationConfig.itemsPerPage;
    return this.facilitiesData.slice(startIndex, endIndex);
  }
  
  get facilitiesTotalItems() {
    return this.facilitiesData.length;
  }

  get facilitiesTotalPages() {
    return Math.ceil(this.facilitiesTotalItems / this.facilitiesPaginationConfig.itemsPerPage);
  }

  get facilitiesPageNumbers(): (number | string)[] {
    const totalPages = this.facilitiesTotalPages;
    const currentPage = this.facilitiesPaginationConfig.currentPage;
    const delta = 2;
    
    let range: number[] = [];
    let rangeWithDots: (number | string)[] = [];
    let l: number | undefined;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
        range.push(i);
      }
    }

    range.forEach(function (i) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    });

    return rangeWithDots;
  }

  get facilitiesDisplayRange(): { start: number; end: number; total: number } {
    const start = (this.facilitiesPaginationConfig.currentPage - 1) * this.facilitiesPaginationConfig.itemsPerPage + 1;
    const end = Math.min(start + this.facilitiesPaginationConfig.itemsPerPage - 1, this.facilitiesTotalItems);
    return {
      start: this.facilitiesTotalItems === 0 ? 0 : start,
      end: this.facilitiesTotalItems === 0 ? 0 : end,
      total: this.facilitiesTotalItems
    };
  }

  // COMPUTED PROPERTIES UNTUK F&B OUTLETS
  get paginatedFBOutlets() {
    const startIndex = (this.fbOutletsPaginationConfig.currentPage - 1) * this.fbOutletsPaginationConfig.itemsPerPage;
    const endIndex = startIndex + this.fbOutletsPaginationConfig.itemsPerPage;
    return this.fbOutletsData.slice(startIndex, endIndex);
  }

  get fbOutletsTotalItems() {
    return this.fbOutletsData.length;
  }

  get fbOutletsTotalPages() {
    return Math.ceil(this.fbOutletsTotalItems / this.fbOutletsPaginationConfig.itemsPerPage);
  }

  get fbOutletsPageNumbers(): (number | string)[] {
    const totalPages = this.fbOutletsTotalPages;
    const currentPage = this.fbOutletsPaginationConfig.currentPage;
    const delta = 2;
    
    let range: number[] = [];
    let rangeWithDots: (number | string)[] = [];
    let l: number | undefined;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
        range.push(i);
      }
    }

    range.forEach(function (i) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    });

    return rangeWithDots;
  }

  get fbOutletsDisplayRange(): { start: number; end: number; total: number } {
    const start = (this.fbOutletsPaginationConfig.currentPage - 1) * this.fbOutletsPaginationConfig.itemsPerPage + 1;
    const end = Math.min(start + this.fbOutletsPaginationConfig.itemsPerPage - 1, this.fbOutletsTotalItems);
    return {
      start: this.fbOutletsTotalItems === 0 ? 0 : start,
      end: this.fbOutletsTotalItems === 0 ? 0 : end,
      total: this.fbOutletsTotalItems
    };
  }

  // METHODS UNTUK FACILITIES PAGINATION
  onFacilitiesPageChange(page: number): void {
    if (page < 1 || page > this.facilitiesTotalPages || page === this.facilitiesPaginationConfig.currentPage) {
      return;
    }
    this.facilitiesPaginationConfig.currentPage = page;
  }

  onFacilitiesFirstPage(): void {
    this.onFacilitiesPageChange(1);
  }

  onFacilitiesPrevPage(): void {
    this.onFacilitiesPageChange(this.facilitiesPaginationConfig.currentPage - 1);
  }

  onFacilitiesNextPage(): void {
    this.onFacilitiesPageChange(this.facilitiesPaginationConfig.currentPage + 1);
  }

  onFacilitiesLastPage(): void {
    this.onFacilitiesPageChange(this.facilitiesTotalPages);
  }

  // METHODS UNTUK F&B OUTLETS PAGINATION
  onFBOutletsPageChange(page: number): void {
    if (page < 1 || page > this.fbOutletsTotalPages || page === this.fbOutletsPaginationConfig.currentPage) {
      return;
    }
    this.fbOutletsPaginationConfig.currentPage = page;
  }

  onFBOutletsFirstPage(): void {
    this.onFBOutletsPageChange(1);
  }

  onFBOutletsPrevPage(): void {
    this.onFBOutletsPageChange(this.fbOutletsPaginationConfig.currentPage - 1);
  }

  onFBOutletsNextPage(): void {
    this.onFBOutletsPageChange(this.fbOutletsPaginationConfig.currentPage + 1);
  }

  onFBOutletsLastPage(): void {
    this.onFBOutletsPageChange(this.fbOutletsTotalPages);
  }

  get facilitiesVisiblePages(): number[] {
    const total = this.facilitiesTotalPages;
    const current = this.facilitiesPaginationConfig.currentPage;
    const maxVisible = window.innerWidth < 768 ? 3 : 5; // Mobile: 3 pages, Desktop: 5 pages
    
    if (!total || total === 0) return [];
    
    let pages: number[] = [];
    
    if (total <= maxVisible + 2) {
      // Tampilkan semua halaman jika total sedikit
      pages = Array.from({ length: total }, (_, i) => i + 1);
    } else {
      // Tampilkan dengan ellipsis
      if (current <= maxVisible - 1) {
        // Di awal
        pages = [...Array(maxVisible).keys(), -1, total].map(x => x + 1);
      } else if (current >= total - (maxVisible - 2)) {
        // Di akhir
        pages = [1, -1, ...Array.from({ length: maxVisible }, (_, i) => total - maxVisible + i + 1)];
      } else {
        // Di tengah
        const start = current - Math.floor((maxVisible - 2) / 2);
        pages = [1, -1, ...Array.from({ length: maxVisible - 2 }, (_, i) => start + i), -1, total];
      }
    }
    
    // Filter undefined dan bersihkan
    return pages.filter(p => p !== undefined).map(p => p === null ? -1 : p);
  }
  get fbOutletsVisiblePages(): number[] {
    const total = this.fbOutletsTotalPages;
    const current = this.fbOutletsPaginationConfig.currentPage;
    const maxVisible = window.innerWidth < 768 ? 3 : 5; // Mobile: 3 pages, Desktop: 5 pages
    
    if (!total || total === 0) return [];
    
    let pages: number[] = [];
    
    if (total <= maxVisible + 2) {
      // Tampilkan semua halaman jika total sedikit
      pages = Array.from({ length: total }, (_, i) => i + 1);
    } else {
      // Tampilkan dengan ellipsis
      if (current <= maxVisible - 1) {
        // Di awal
        pages = [...Array(maxVisible).keys(), -1, total].map(x => x + 1);
      } else if (current >= total - (maxVisible - 2)) {
        // Di akhir
        pages = [1, -1, ...Array.from({ length: maxVisible }, (_, i) => total - maxVisible + i + 1)];
      } else {
        // Di tengah
        const start = current - Math.floor((maxVisible - 2) / 2);
        pages = [1, -1, ...Array.from({ length: maxVisible - 2 }, (_, i) => start + i), -1, total];
      }
    }
    
    // Filter undefined dan bersihkan
    return pages.filter(p => p !== undefined).map(p => p === null ? -1 : p);
  }
  // Optional: Update saat window resize
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    // Trigger change detection jika perlu
    // Ini akan otomatis update facilitiesVisiblePages
  }
    // Buat computed property untuk filter data 'Total' saja
  get totalRevenueOnly(): HotelDetailRevenue[] {
    return this.revenueItem.filter(item => item.name === 'Total');
  }
  getPercentageClass(percentage: number): string {
    if (percentage >= 100) {
      return 'badge custom-progress-success';
    }
    return 'badge custom-progress-danger';
  }
}